import React from 'react'

export default function JoinedOn({value}) {
  return (
    <div className='form-group row'>
      <label className='control-label col-lg-3'>Joined On</label>
      <div className='col-lg-9'>
        <input className='form-control' defaultValue={value} disabled={true} />
      </div>
    </div>
  )
}
